<script>
export default {
  name: "UserDeleteConfirmation",
  props: {
    title: { type: String, default: () => "" },
  },
};
</script>

<template>
  <v-card>
    <v-card-title class="headline">{{ title }}</v-card-title>
    <v-card-text><slot></slot></v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text @click="$emit('close')">いいえ</v-btn>
      <v-btn class="confirmBtn" text @click="$emit('confirm')">はい</v-btn>
    </v-card-actions>
  </v-card>
</template>
